






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class BlockView extends Vue {

}
